var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgDotsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 134,
    viewBox: "0 0 107 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 104.999 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 104.999 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 104.999 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 104.999 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 104.999 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 104.999 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 104.999 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 104.999 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 104.999 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.999,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 104.999 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 90.3333 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 90.3333 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 90.3333 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 90.3333 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 90.3333 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 90.3333 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 90.3333 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 90.3333 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 90.3333 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3333,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 90.3333 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 75.6654 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 31.9993 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 75.6654 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 31.9993 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 75.6654 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 31.9993 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 75.6654 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 31.9993 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 75.6654 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 31.9993 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 75.6654 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 31.9993 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 75.6654 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 31.9993 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 75.6654 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 31.9993 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 75.6654 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 31.9993 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.6654,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 75.6654 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9993,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 31.9993 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 60.9993 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 17.3333 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 60.9993 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 17.3333 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 60.9993 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 17.3333 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 60.9993 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 17.3333 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 60.9993 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 17.3333 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 60.9993 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 17.3333 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 60.9993 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 17.3333 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 60.9993 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 17.3333 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 60.9993 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 17.3333 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.9993,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 60.9993 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3333,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 17.3333 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 46.3333 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 132,
    r: 1.66667,
    transform: "rotate(180 2.66536 132)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 46.3333 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 117.333,
    r: 1.66667,
    transform: "rotate(180 2.66536 117.333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 46.3333 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 102.667,
    r: 1.66667,
    transform: "rotate(180 2.66536 102.667)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 46.3333 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 88,
    r: 1.66667,
    transform: "rotate(180 2.66536 88)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 46.3333 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 73.3333,
    r: 1.66667,
    transform: "rotate(180 2.66536 73.3333)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 46.3333 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 45,
    r: 1.66667,
    transform: "rotate(180 2.66536 45)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 46.3333 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 16,
    r: 1.66667,
    transform: "rotate(180 2.66536 16)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 46.3333 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 59,
    r: 1.66667,
    transform: "rotate(180 2.66536 59)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 46.3333 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 30.6666,
    r: 1.66667,
    transform: "rotate(180 2.66536 30.6666)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3333,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 46.3333 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.66536,
    cy: 1.66665,
    r: 1.66667,
    transform: "rotate(180 2.66536 1.66665)",
    fill: "rgb(59 130 246 / 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDotsBlue);
export default __webpack_public_path__ + "static/media/svgDotsBlue.df543298ea90840f193c1337189ef1f7.svg";
export { ForwardRef as ReactComponent };